export default function SmallStat({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="mb-1 text-sm opacity-60">{label}</div>
      <div className="text-base font-medium">{value}</div>
    </div>
  )
}
